import PropTypes from "prop-types";
import templateService from "../../../services/templateService";
import { useEffect, useState } from "react";
import { useNotification } from "context/NotificationContext";
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Card,
  Grid,
} from "@mui/material";
import MDBox from "components/MDBox";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

const ActionTemplate = (props) => {
  const { templateId, templateName, onTemplateUpdate, onNameUpdate } = props;
  const { showNotification } = useNotification();
  const [name, setName] = useState(templateName);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setName(templateName);
  }, [templateName]);

  const editName = async () => {
    setSubmitting(true);
    try {
      await templateService.updateTemplateById({ id: templateId, name });
      showNotification("Nombre actualizado correctamente", "success");
      onNameUpdate(templateId, name);
    } catch {
      showNotification("Error al actualizar el nombre", "error");
    } finally {
      setSubmitting(false);
    }
  };

  const deleteTemplate = async () => {
    const shouldDelete = window.confirm("¿Realmente desea eliminar esta plantilla?");
    if (!shouldDelete) return;
    setSubmitting(true);
    try {
      await templateService.deleteTemplateById(templateId);
      showNotification("Plantilla eliminada correctamente", "success");
      onTemplateUpdate(true);
    } catch {
      showNotification("Error al eliminar la plantilla", "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card>
      <MDBox position="relative" p={1}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={12}>
            <Accordion
              style={{ boxShadow: "none" }}
              sx={{
                boxShadow: 2,
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark"
                    ? theme.palette.action.hover
                    : "transparent !important",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <MDTypography display="block" variant="button" fontWeight="regular">
                  {templateName}
                </MDTypography>
              </AccordionSummary>
              <AccordionDetails>
                <MDBox>
                  <MDInput
                    fullWidth
                    type="text"
                    label="Nombre"
                    value={name}
                    onChange={(event) => {
                      setName(event.target.value);
                    }}
                  />
                </MDBox>
              </AccordionDetails>
              <AccordionActions>
                <MDButton variant="gradient" color="success" onClick={editName} disabled={submitting}>
                  Guardar
                </MDButton>
                <MDButton variant="gradient" color="error" onClick={deleteTemplate} disabled={submitting}>
                  Eliminar
                </MDButton>
              </AccordionActions>
            </Accordion>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
};

ActionTemplate.propTypes = {
  templateId: PropTypes.number.isRequired,
  templateName: PropTypes.string.isRequired,
  onTemplateUpdate: PropTypes.func,
  onNameUpdate: PropTypes.func,
};

export default ActionTemplate;
